export default "/institutions/sicredi.svg";